import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrompt = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 12 12",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 0C2.69 0 0 2.69 0 6C0 9.31 2.69 12 6 12C9.31 12 12 9.31 12 6C12 2.69 9.31 0 6 0ZM6 11C3.24 11 1 8.76 1 6C1 3.24 3.24 1 6 1C8.76 1 11 3.24 11 6C11 8.76 8.76 11 6 11Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 4.84998C5.72 4.84998 5.5 5.06998 5.5 5.34998V8.74998C5.5 9.02998 5.72 9.24998 6 9.24998C6.28 9.24998 6.5 9.02998 6.5 8.74998V5.34998C6.5 5.07998 6.28 4.84998 6 4.84998Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.01 2.8C5.75 2.78 5.51 3.05 5.5 3.32C5.5 3.33 5.5 3.39 5.5 3.4C5.5 3.67 5.71 3.87 5.99 3.88H6C6.27 3.88 6.49 3.64 6.5 3.38C6.5 3.37 6.5 3.27 6.5 3.27C6.5 2.98 6.29 2.8 6.01 2.8Z" })
	]
});
export default SvgPrompt;
